import React from "react";
import { Grid, Typography } from "@material-ui/core";
import moment from "moment";
import useStyles from "./styles";
import { translate as t } from "../../../../../../../infrastructure/translate/localization";

interface Approver {
  timestamp: number;
  email: string;
}

export default function Approvers({ data }: { data: Approver[] }): JSX.Element {
  const {
    approversContainer,
    approverEmail,
    approversSeparator,
    approverType,
    dateLabel,
  } = useStyles({
    multiple: data.length > 1,
  });

  const parseDate = (timestamp) => {
    const transformDate = moment(new Date(timestamp * 1000));
    return `${transformDate.format("D")} ${transformDate.format(
      "MMM"
    )} ${transformDate.format("YYYY")} ${t(
      "common-messages.at"
    )} ${transformDate.format("HH:mm")}`;
  };

  return (
    <Grid container className={approversContainer}>
      <Grid>
        <Typography variant="body2" className={approverType}>
          {t("recurrent-payments-section.hr-approval")}
        </Typography>
        <Typography variant="body2" className={dateLabel}>
          {parseDate(data[0].timestamp)}
        </Typography>
      </Grid>
      <Typography variant="body2" className={approverEmail}>
        {data[0].email}
      </Typography>
      {data.length > 1 && (
        <>
          <Grid className={approversSeparator} />
          <Grid>
            <Typography variant="body2" className={approverType}>
              {t("recurrent-payments-section.finance-approval")}
            </Typography>
            <Typography variant="body2" className={dateLabel}>
              {parseDate(data[1].timestamp)}
            </Typography>
          </Grid>
          <Typography variant="body2" className={approverEmail}>
            {data[1].email}
          </Typography>
        </>
      )}
    </Grid>
  );
}
